import { useContext } from 'react';
import { ToastContext } from '../components/Toast/ToastProvider';
import { ToastType } from '../components/Toast/Toast';

export const useToast = () => {
  const context = useContext(ToastContext);

  return {
    ...context,
    openError: (content: string) => context.open(content, ToastType.ERROR),
    openSuccess: (content: string) => context.open(content, ToastType.SUCCESS),
  };
};
